import React from 'react'
import { Message } from 'semantic-ui-react'

export const ImageErrors = ({ errors }: { errors: string[] }) => {
  if (errors.length === 0) return null

  return (
    <Message color="red">
      <Message.Header>Photo Upload Errors</Message.Header>
      <Message.List items={errors} />
    </Message>
  )
}
